angular.module('SpidApp')

.factory('LocalDistantAdapterFactory',
        ['UserAdapterConfig'
         , 'AgencyAdapterConfig'
         , 'ProductAdapterConfig'
         , 'VacationAdapterConfig'
         , 'CashAdapterConfig'
         , 'BusinessDayAdapterConfig'
         , 'TransactionAdapterConfig'
         , 'OperationalProductAdapterConfig'
         , 'OrderAdapterConfig'
         , 'OrderItemAdapterConfig'
         , 'OrderStatusAdapterConfig'
         , 'SaleAdapterConfig'
         , 'CurrencyAdapterConfig'
         , 'CurrencyHistoryAdapterConfig'
         , 'InventoryAdapterConfig'
         , 'StockAdapterConfig'
         , 'StockFlowAdapterConfig'
         
         , 'AffranchissementAdapterConfig'
         , 'ChoixOptionAffranchissementDestinationAdapterConfig'
         , 'ComplementServiceAffranchissementDestinationAdapterConfig'
         , 'DestinationAdapterConfig'
         , 'DestinationZoneAdapterConfig'
         , 'OptionAffranchissementDestinationAdapterConfig'
         , 'PrixServiceAffranchissementDestinationAdapterConfig'
         , 'PrixTrancheAffranchissementZoneAdapterConfig'
         , 'RestrictionAdapterConfig'
         , 'ServiceAffranchissementDestinationAdapterConfig'
         , 'ZoneAffranchissementAdapterConfig'
         , 'MoneyTransferAdapterConfig'
,   function (UserAdapterConfig
    , AgencyAdapterConfig
    , ProductAdapterConfig
    , VacationAdapterConfig
    , CashAdapterConfig
    , BusinessDayAdapterConfig
    , TransactionAdapterConfig
    , OperationalProductAdapterConfig
    , OrderAdapterConfig
    , OrderItemAdapterConfig
    , OrderStatusAdapterConfig
    , SaleAdapterConfig
    , CurrencyAdapterConfig
    , CurrencyHistoryAdapterConfig
    , InventoryAdapterConfig
    , StockAdapterConfig
    , StockFlowAdapterConfig
    
    , Affranchissement
    , ChoixOptionAffranchissementDestinationAdapterConfig
    , ComplementServiceAffranchissementDestinationAdapterConfig
    , DestinationAdapterConfig
    , DestinationZoneAdapterConfig
    , OptionAffranchissementDestinationAdapterConfig
    , PrixServiceAffranchissementDestinationAdapterConfig
    , PrixTrancheAffranchissementZoneAdapterConfig
    , RestrictionAdapterConfig
    , ServiceAffranchissementDestinationAdapterConfig
    , ZoneAffranchissementAdapterConfig
    , MoneyTransferAdapterConfig) {
        	 
  var adapterConfigs = [
      UserAdapterConfig
    , ProductAdapterConfig
    , VacationAdapterConfig
    , CashAdapterConfig
    , BusinessDayAdapterConfig
    , TransactionAdapterConfig
    , OperationalProductAdapterConfig
    , AgencyAdapterConfig
    , OrderAdapterConfig
    , OrderItemAdapterConfig
    , OrderStatusAdapterConfig
    , SaleAdapterConfig
    , CurrencyAdapterConfig
    , CurrencyHistoryAdapterConfig
    , InventoryAdapterConfig
    , StockAdapterConfig
    , StockFlowAdapterConfig
    
    , Affranchissement
    , ChoixOptionAffranchissementDestinationAdapterConfig
    , ComplementServiceAffranchissementDestinationAdapterConfig
    , DestinationAdapterConfig
    , DestinationZoneAdapterConfig
    , OptionAffranchissementDestinationAdapterConfig
    , PrixServiceAffranchissementDestinationAdapterConfig
    , PrixTrancheAffranchissementZoneAdapterConfig
    , RestrictionAdapterConfig
    , ServiceAffranchissementDestinationAdapterConfig
    , ZoneAffranchissementAdapterConfig
    , MoneyTransferAdapterConfig
  ]

  var LocalDistantAdapterFactory = {}
  _.each(adapterConfigs, function (config) {
    LocalDistantAdapterFactory[config.name] = {

      toDistantFormat: function (object) {
        if (!object) {
          throw 'LocalDistantAdapterFactory::' + config.name + '::toDistantFormat() - Missing parameters'
        }

        var resObject = {}

        for(var i in config.fields) {
          var field = config.fields[i]

          var destKey = field.distant
          var fromKey = field.local

          resObject[destKey] = object[fromKey]
        }
        
        return resObject
      },

      toLocalFormat: function (object) {
        if (!object) {
          throw 'LocalDistantAdapterFactory::' + config.name + '::toLocalFormat() - Missing parameters'
        }

        var resObject = {}

        for(var i in config.fields) {
          var field = config.fields[i]

          var destKey = field.local
          var fromKey = field.distant

          resObject[destKey] = object[fromKey]
        }
        
        return resObject
      }

    }

  })

  return LocalDistantAdapterFactory
}])
